//payroll redux slice
import { createSlice } from "@reduxjs/toolkit";

export const filterSlice = createSlice({
  name: "filterSlice",
  initialState: {
   statusShowOptions:null
  },
  reducers: {
    setStatusShowOption: (state, action) => {
      state.statusShowOptions = action.payload;
    },
  },
});

export const {setStatusShowOption} = filterSlice.actions;

export default filterSlice.reducer;
